function DeliveryAddress(deliveryAddress) {
    this.id = deliveryAddress.id || null;
    this.name = deliveryAddress.name || '';
    this.firstName = deliveryAddress.first_name || '';
    this.lastName = deliveryAddress.last_name || '';
    this.street = deliveryAddress.street || '';
    this.city = deliveryAddress.city || '';
    this.zipcode = deliveryAddress.zipcode || '';
    this.ico = deliveryAddress.ico || '';
    this.dic = deliveryAddress.dic || '';
    this.phone = deliveryAddress.phone || '';
    this.email = deliveryAddress.email || '';
}

export default DeliveryAddress;
